import { defineStore } from "pinia";
import apiService from "../services/api";

export interface GuideProgress {
  completed: boolean;
  dismissedStep?: number;
}

export const useGuideStore = defineStore("guides", {
  state: () => ({
    progress: JSON.parse(localStorage.getItem("guides") || "{}") as Record<string, GuideProgress>
  }),
  actions: {
    setProgress(guideId: string, data: GuideProgress) {
      this.progress[guideId] = data;
      localStorage.setItem("guides", JSON.stringify(this.progress));
    }
    ,
    async loadFromApi() {
      try {
        const response = await apiService.getGuideEvents();
        if (response.success && response.data) {
          for (const ev of response.data) {
            this.progress[ev.guideId] = {
              completed: ev.completed,
              dismissedStep: ev.dismissedStep,
            };
          }
          localStorage.setItem("guides", JSON.stringify(this.progress));
        }
      } catch {
        // ignore errors (e.g. when unauthenticated)
      }
    }
  }
});
